import { useState, useEffect, useRef } from "react";
import { BUILD_ID } from "@/lib/buildVersion";

/**
 * Polls /build-meta.json to detect when a newer build is deployed.
 * Dispatches a "new-version-available" CustomEvent once on first detection.
 */
export function useVersionPoll(intervalMs = 60_000) {
  const [isStale, setIsStale] = useState(false);
  const notifiedRef = useRef(false);

  useEffect(() => {
    if (BUILD_ID === "dev") return;

    const check = async () => {
      try {
        const res = await fetch(`/build-meta.json?_=${Date.now()}`, {
          cache: "no-store",
        });
        if (!res.ok) return;
        const data = await res.json();
        if (data.buildId && data.buildId !== BUILD_ID) {
          setIsStale(true);
          if (!notifiedRef.current) {
            notifiedRef.current = true;
            window.dispatchEvent(
              new CustomEvent("new-version-available", {
                detail: { buildId: data.buildId },
              })
            );
          }
        }
      } catch {
        // network error – silent
      }
    };

    // First check after 15s, then every intervalMs
    const t1 = setTimeout(check, 15_000);
    const t2 = setInterval(check, intervalMs);
    return () => {
      clearTimeout(t1);
      clearInterval(t2);
    };
  }, [intervalMs]);

  return { isStale };
}
